import { Box, Flex, Text } from '@chakra-ui/react'
import CardImage from '@/components/CardImage'

export default function SimilarBehaviors({ data }: any) {

  return (
    <Flex
      direction="column"
      bgColor="#FFF"
      boxShadow="0px 1px 2px 0px rgba(0, 0, 0, 0.06), 0px 1px 3px 0px rgba(0, 0, 0, 0.10)"
      borderRadius="16px"
    >
      <Flex
        p={{ base: "16px", lg: "32px" }}
        direction="column"
        gap="32px"
      >
        <Text
          fontSize={{ base: "24px", lg: "36px" }}
          lineHeight={{ base: "32px", lg: "40px" }}
          fontWeight="700"
          color="gray.800"
        >
          Comportamentos semelhantes
        </Text>
        <Flex flexWrap="wrap" width="100%" gap="22px" rowGap={{ base: "24px", lg: "32px" }}>
          {data.slice(0, 8)
            .map((item: any, i: number) => (
              <Box key={i} height="202px" width={{ base: "100%", lg: "auto" }}>
                <CardImage
                  tag
                  isBreed
                  width="166px"
                  key={item.id}
                  post={item}
                />
              </Box>
            ))}
        </Flex>
      </Flex>
    </Flex>

  )
}
